module.exports = __webpack_public_path__ + "img/jc1.e1a8a54c.png";